<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="tab">
          <span v-for="(item,index) in tabArr" :key="index" @click="toTab(index,item)" :class="tabIndex==index?'active':''">{{item}}</span>
        </div>
        <div class="list">
          <router-link :to="{path:'/CollectionA1Detail/'+item.id}" tag="div" class="item" v-for="(item,index) in dataList" :key="index">
            <img :src="item.picUrl" alt="">
            <div class="title text-hide">{{item.title}}</div>
          </router-link>
          <div style="clear: both"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[6, 12, 18, 24, 30]"
            :page-size="6"
            layout="total, sizes, prev, pager, next, jumper"
            :total="config.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {listShowGoods,getGoodsType} from "@/api"
  // import {getCollectionA1} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "List",
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 选项卡
        tabArr : [],
        tabIndex : 0,
        // 分页参数
        config: {
          classify: '',
          total: 0,
          page: 1,
          limit: 6
        },
        // 列表数据
        dataList:[]
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.tabArr = [this.$t('otherPage.p15')]
        this.tabIndex = 0
        // 获取数据
        this.toGetData()
        this.getData()
      }
    },
    created(){

      // 获取数据
      this.toGetData()
      this.getData()
    },
    methods:{
      // 选项卡
      toTab(index,value){
        this.config.page = 1
        this.tabIndex = index
        this.config.classify = value == '全部' || value == 'All'?'':value
        this.toGetData()
        this.getData(value)
      },
      // 获取数据
      async toGetData() {
        this.tabArr= [this.$t('otherPage.p15')]
        let  dictType = this.$store.getters.lang == 'en'?'showgoods_type_en':'showgoods_type'
        let {data:{data}} = await getGoodsType({dictType})
        data.forEach((val)=>{
          this.tabArr.push(val.dictLabel)
        })
      },
      async getData(value) {

        let goodsType = value == '全部' ||  value == 'All' ? '' : value ? value :  this.tabArr[this.tabIndex] == '全部' || this.tabArr[this.tabIndex] == 'All'? '' : this.tabArr[this.tabIndex]

        this.dataList = []
        let params = {}
        if(this.$store.getters.lang == 'en'){
           params = {
            pageNum: this.config.page,
            pageSize: this.config.limit,
            orderByColumn: "create_time",
            goodsTypeEn :goodsType
          }
        }else{
          params = {
            pageNum: this.config.page,
            pageSize: this.config.limit,
            orderByColumn: "create_time",
            goodsType :goodsType
          }
        }


        let {data:{rows,total}} = await listShowGoods(params)
        // console.log("params",params);
        // console.log("rows",rows);


        rows.forEach( val =>{
          this.dataList.push({
            id : val.id,
            title : this.$store.getters.lang == 'en' ? val.goodsTitleEn : val.goodsTitle,
            picUrl : this.$store.getters.urlApi + val.goodsFace,
            classify : this.$store.getters.lang == 'en' ? val.goodsTypeEn : val.goodsType,
            age : this.$store.getters.lang == 'en' ? val.goodsClassEn : val.goodsClass
          })
          // let arr = val.goodsFace ? val.goodsFace.split(',') : []
          // arr.forEach((val2,index2)=>{
          //   arr[index2] = this.$store.getters.urlApi + val2
          // })
          // let arrEn = val.goodsFaceEn ? val.goodsFaceEn.split(',') : []
          // arrEn.forEach((val2,index2)=>{
          //   arrEn[index2] = this.$store.getters.urlApi + val2
          // })
          // rows[index].faceUrl = arr
          // rows[index].faceUrlEn = arrEn
        })
        this.config.total = total
      },
      // toGetData() {
      //   getCollectionA1(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      // 分页事件
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
        this.getData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
        this.getData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }
  .container{
    .wrap{
      .tab{
        display: flex;
        justify-content: center;
        margin-bottom: 60px;
        span{
          height: 52px;
          line-height: 52px;
          font-size: 24px;
          background: #333333;
          color: #FFFFFF;
          margin: 0 20px;
          cursor: pointer;
          width: 144px;
          text-align: center;
        }
        span.active{
          background: #DA1E2D;
        }
      }
      .list{
        width: 1440px;
        margin: 0 auto 110px;
        .item{
          width: 440px;
          height: 382px;
          background: #FFFFFF;
          box-shadow: 0 5px 30px 0 rgba(0,0,0,0.15);
          margin: 0 15px 30px;
          float: left;
          padding: 20px 20px 0;
          cursor: pointer;
          .title{
            font-family: PingFangSC;
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            margin-top: 24px;
            text-align: center;
          }
          img{
            width: 100%;
            height: 285px;
          }
        }
        .item:hover{
          .title{
            color: #DA1E2D !important;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Collection/A1/List.vue